import { render, staticRenderFns } from "./ExpressList.vue?vue&type=template&id=6d8e5ca4&scoped=true"
import script from "./ExpressList.vue?vue&type=script&lang=js"
export * from "./ExpressList.vue?vue&type=script&lang=js"
import style0 from "./ExpressList.vue?vue&type=style&index=0&id=6d8e5ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e5ca4",
  null
  
)

export default component.exports